import Component from "@ember/component"
import { action, computed, get, set } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import findDocument from "cc-frontend/helpers/find-document"
import findMany from "cc-frontend/helpers/find-many-individually"
import HasManyAltogether from "cc-frontend/helpers/has-many-altogether"
import courseAnalyzeStandardsTrackerAction from "cc-frontend/lib/actions/course/COURSE_ANALYZE_STANDARDS_TRACKER"
import { use } from "ember-could-get-used-to-this"
import _ from "lodash"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class StandardsTracker extends Component {
  @service("dispatcher")
  dispatcher

  @service("ember-store")
  store

  @service
  rpc

  @service
  appState

  @computed("selectedCourses.@each.content")
  get availableStandardSetIds() {
    let courseIds = _.reject(
      _.map(get(this, "selectedCourses"), (course) => get(course, "id")),
      (id) => id === undefined
    )
    if (courseIds.length > 0) {
      return ObjectPromiseProxy.create({
        promise: get(this, "rpc").execute("STANDARDS_REPORT_FIND_STANDARD_SET_IDS", courseIds),
      })
    }
  }

  @use courses = new HasManyAltogether(() => [this.planbook, "courses", "course"])

  @computed("courses.isPending", "courses.content.[]")
  get instructionalCourses() {
    if (this.courses.isPending) return []
    return this.courses.content.filter((course) => !course.attributes.isNonInstructional)
  }

  @findMany("courseIds", "course")
  selectedCourses

  @computed("standardSetId", "courseIds.[]")
  get hierarchicalStandardsReport() {
    let courseIds = get(this, "courseIds")
    let standardSetId = get(this, "standardSetId")
    if (courseIds.length > 0 && standardSetId) {
      return ObjectPromiseProxy.create({
        promise: get(this, "rpc").execute("STANDARDS_REPORT", courseIds, [standardSetId]),
      })
    }
  }

  @findDocument("standardSetId", "standard-set")
  selectedStandardSet

  @findMany("availableStandardSetIds.content", "standard-set")
  standardSets

  @computed("selectedStandardSet.attributes.standards")
  get standards() {
    return _(get(this, "selectedStandardSet.attributes.standards"))
      .values()
      .sortBy("position")
      .value()
  }

  @action
  selectSet(id) {
    if (get(this, "standardSetId") === id) {
      set(this, "standardSetId", null)
    } else {
      set(this, "standardSetId", id)
    }
  }

  @action
  toggleCourse(id) {
    if (_.includes(get(this, "courseIds"), id)) {
      get(this, "courseIds").removeObject(id)
    } else {
      get(this, "courseIds").pushObject(id)
    }
    this.set("selectedCourseId", id)
  }

  trackView = () => {
    let selectedCourseId = this.selectedCourseId
    this.dispatcher.dispatchPreparedAction(
      courseAnalyzeStandardsTrackerAction({
        courseId: selectedCourseId,
        planbook: this.planbook,
        selectedStandardSetSubject: get(this, "selectedStandardSet.attributes.subject"),
        selectedStandardSetTitle: get(this, "selectedStandardSet.attributes.title"),
      })
    )
  }
}
